(function () {
    /**
     * This is a legacy way of joining a Choop.Chat group meeting.
     * It just asks the server for a join url and redirects there.
     *
     * @deprecated We should no longer use this method.
     *  Conferences should be started by opening a window with <ty-videoconference-app>
     */
    angular.module('tradersyard').component('tyJoinMeeting', {
        // language=Angular2Html
        template:
            '<div class="ty-join-meeting-box">\n    <div ng-if="!$ctrl.error">\n        <h1>\n            Joining the meeting...\n            <i class="fa fa-x4 fa-spinner fa-spin"></i>\n        </h1>\n    </div>\n    <div ng-if="$ctrl.error">\n        <h1><i class="fa error fa-exclamation-triangle"></i> Error joining the meeting!</h1>\n        <p>{{ $ctrl.error }}</p>\n    </div>\n</div>',
        bindings: {},
        controller: JoinMeetingComponent,
    });

    JoinMeetingComponent.$inject = ['graph-api-client', '$location', '$window', '$timeout'];

    function JoinMeetingComponent(apiClient, $location, $window, $timeout) {
        var ctrl = this;

        ctrl.error = false;

        ctrl.$onInit = function () {
            try {
                var queryParams = getMeetingRoomParams($location.search());
            } catch (e) {
                // do this in a timeout so there is a feeling of loading something instead of failing right away
                // This will give people time to read they are Joining the meeting...
                return $timeout(function () {
                    ctrl.error = e.toString();
                }, 500);
            }

            ctrl.joinMeeting(getRoomName(queryParams));
        };

        ctrl.joinMeeting = function (roomName) {
            getMeetingUrl(roomName)
                .then(function (response) {
                    $window.open(response.data.data.join_url, '_self');
                })
                .catch(function (error) {
                    console.warn('Unable to join meeting', error);
                    ctrl.error = 'Please make sure you are allowed to join the meeting.';
                });
        };

        /**
         * @returns {Promise}
         * @deprecated
         */
        function getMeetingUrl(roomName) {
            return apiClient.post('meeting/web-join-url', {
                room_name: roomName,
            });
        }

        /**
         * @typedef MeetingRoomParams
         * @property {string} room_type - Type of the room to join to (group, webinar)
         * @property {number} room_type_id - ID of the room type (group ID, webinar ID)
         * @returns MeetingRoomParams
         */
        function getMeetingRoomParams(queryParams) {
            if (!validateQueryParams(queryParams)) {
                throw new Error('Required meeting parameters not provided in the URL.');
            }

            return queryParams;
        }

        function validateQueryParams(queryParams) {
            return queryParams.room_type && queryParams.room_type_id;
        }

        /**
         * @param {MeetingRoomParams} queryParams
         * @returns {string}
         */
        function getRoomName(queryParams) {
            return queryParams.room_type + '-' + queryParams.room_type_id;
        }
    }
})();
